// Shared allowlist for the standalone marketing app. Used by both the
// MarketingScripts loader and the ConsentBanner so the banner and tracker
// gating cannot drift.


export const PUBLIC_PATHS: ReadonlySet<string> = new Set([
  "/",
  "/terms",
  "/privacy",
]);


export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.has(pathname);
}
